const experimentUniverses = {
    CONCEPT_FUNNEL: "ConceptFunnel",
    RECAL_PRICE_REMOVAL: "NextGen_RecalPriceRemoval",
    MSR: "MSR",
    IGQ_SkipQuote: "NextGen_IGQSkipToInsurance",
    AFTERPAY_BREAKOUT_DISPLAY: "AfterpayBreakoutDisplay",
};

const experimentSettings = {
    GOOGLE_CUSTOM_DIMENSION_INDEX: "Google Custom Dimension Index",
    SUPPRESS_VIN_CAPTURE: "SuppressVinCapture",
    DISPLAY_AVAILABILITY_INDICATORS: "DisplayAvailabilityIndicators",
    PIA_EXPERIENCE: "PIA Experience",
    PIA_INSURANCE: "DisplayPIAInsurance",
    SUBMIT_ORDER_ENABLE_PIA: "SubmitOrder_Enable_PIA",
    IS_EMAIL_OPTIONAL: "isEmailOptional",
    SERVICE_PACKAGE_DISCOUNT: "OfferServicePackageDiscount",
    PROMO_ON_PACKAGE: "Offer_Promo_On_Pkg",
    RECAL_PRICE_REMOVE: "RecalPriceRemove",
    INSURANCE_TAB_TO_DISPLAY_THRESHOLD_INTERNAL: "NextGen_InternalInsuranceTabDisplayThreshold",
    INSURANCE_TAB_TO_DISPLAY_THRESHOLD_EXTERNAL: "NextGen_ExternalInsuranceTabDisplayThreshold",
    DISPLAY_MSR: "DisplayMSR",
    DISPLAY_WAITLIST: "DisplayWaitlist2.0",
    WAITLIST_THRESHOLD_DAYS: "Waitlist_Threshold_Days",
    PRICING_BY_DAY: "DisplayPricingByDay",
    FOSTER_LOVE: "DisplayFosterLove",
    SKIP_TO_INSURANCE: "SkipToInsurance",
    DISPLAY_AFTERPAY_BREAKOUT_DISPLAY: "Display_AfterpayBreakoutDisplay",
};

const experimentTriggers = {
    SITE_ENTRY: "SiteEntry",
    PAGE_ENTRY: "PageEntry",
};

export { experimentUniverses, experimentSettings, experimentTriggers };
